import { Grid } from '@backstage/ui';
import { Entity } from '@backstage/catalog-model';
import { EntityLayout } from './entity-layout';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../core/i18n';
import layoutStyles from './layouts.module.css';
import {
  EntityWarningContent,
  AboutCard,
  EntityGraphCard,
  LinksCard,
  HasComponentsCard,
} from '../components';
import { DbExplorerTab } from '../components/db-explorer';

const isDatabase = (entity: Entity) =>
  (entity.spec as { type?: string })?.type === 'database';

const OverviewContent = () => (
  <Grid.Root columns="12" gap="3" className={layoutStyles.gridStretch}>
    <EntityWarningContent />

    <Grid.Item colSpan={{ xs: '12', md: '8' }}>
      <Grid.Root columns="1" gap="3" className={layoutStyles.gridStretch}>
        <Grid.Item colSpan="1">
          <AboutCard />
        </Grid.Item>
        <Grid.Item colSpan="1">
          <HasComponentsCard />
        </Grid.Item>
      </Grid.Root>
    </Grid.Item>

    <Grid.Item colSpan={{ xs: '12', md: '4' }}>
      <Grid.Root columns="1" gap="3" className={layoutStyles.gridStretch}>
        <Grid.Item colSpan="1">
          <LinksCard />
        </Grid.Item>
        <Grid.Item colSpan="1">
          <EntityGraphCard height={300} />
        </Grid.Item>
      </Grid.Root>
    </Grid.Item>
  </Grid.Root>
);

export const ResourceEntityLayout = () => {
  const { t } = useTranslationRef(appTranslationRef);

  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title={t('entity.tabs.overview')}>
        <OverviewContent />
      </EntityLayout.Route>

      <EntityLayout.Route
        path="/database"
        title={t('entity.tabs.database')}
        if={isDatabase}
      >
        <DbExplorerTab />
      </EntityLayout.Route>
    </EntityLayout>
  );
};
